import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { RouterModule } from '@angular/router';
import { HeaderAlertComponent } from '@components/alert/header-alert.component';
import { CountdownComponent } from '@components/countdown/countdown.component';
import { InstallAppDialogComponent } from '@components/dialog/install-app-dialog/install-app-dialog.component';
import { DialogWorldwideComponent } from '@components/dialog/worldwide-dialog/worldwide-dialog.component';
import { FaqComponent } from '@components/faq/faq.component';
import { PaymentSystemsComponent } from '@components/payment-systems/payment-systems.component';
import { RaffleInstantLogoComponent } from '@components/raffle-instant-badge/raffle-instant-logo.component';
import { StickyNavComponent } from '@components/sticky-nav/sticky-nav.component';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { TicketCardComponent } from '@components/ticket-card/ticket-card.component';
import { TrustpilotComponent } from '@components/trustpilot/trustpilot.component';
import { VideojsComponent } from '@components/videojs/videojs.component';
import { PluralizePipe } from '@custom-pipes/index';
import { SafeHtmlPipe } from '@custom-pipes/safe-html/safe-html.pipe';
import { NotFoundComponent } from '@project/components/not-found/not-found.component';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import SwiperCore, {
  Autoplay,
  Lazy,
  Navigation,
  Pagination,
  Scrollbar
} from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { DatetimeModule } from '../datetime/datetime.module';
import { GalleryDialogComponent } from './components/gallery-dialog/gallery-dialog.component';
import { GalleryImageComponent } from './components/gallery-image/gallery-image.component';
import { GalleryPanoramaComponent } from './components/gallery-panorama/gallery-panorama.component';
import { GalleryVideoComponent } from './components/gallery-video/gallery-video.component';
import { PrizeCardComponent } from './components/prize-card/prize-card.component';
import { ProductCloseDetailsComponent } from './components/product-close-details/product-close-details.component';
import { ProductConditionsComponent } from './components/product-conditions/product-conditions.component';
import { ProductDialogComponent } from './components/product-dialog/product-dialog.component';
import { ProductEndPrizeComponent } from './components/product-end-prize/product-end-prize.component';
import { ProductGalleryComponent } from './components/product-gallery/product-gallery.component';
import { ProductHowWorksComponent } from './components/product-how-works/product-how-works.component';
import { ProductComponent } from './product/product.component';
import { ModalRepeatPurchaseComponent } from '@components/modals/modal-repeat-purchase/modal-repeat-purchase.component';
import { TemplateModule } from '@project/shared/template/template.module';
import { ProductTicketsComponent } from './product/components/product-tickets/product-tickets.component';

SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay, Lazy]);

@NgModule({
  declarations: [
    ProductGalleryComponent,
    ProductDialogComponent,
    GalleryDialogComponent,
    GalleryPanoramaComponent,
    GalleryVideoComponent,
    GalleryImageComponent,
    PrizeCardComponent,
    ProductComponent,
    ProductEndPrizeComponent,
    ProductHowWorksComponent,
    ProductConditionsComponent,
    ProductCloseDetailsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SwiperModule,
    MatSliderModule,
    SvgIconComponent,
    TicketCardComponent,
    StickyNavComponent,
    FaqComponent,
    ShareButtonsModule,
    ShareIconsModule,
    InstallAppDialogComponent,
    DialogWorldwideComponent,
    PaymentSystemsComponent,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    DatetimeModule,
    SafeHtmlPipe,
    NotFoundComponent,
    TrustpilotComponent,
    CountdownComponent,
    RaffleInstantLogoComponent,
    VideojsComponent,
    HeaderAlertComponent,
    CountdownComponent,
    PluralizePipe,
    ModalRepeatPurchaseComponent,
    TemplateModule,
    ProductTicketsComponent
  ],
  exports: [ProductComponent]
})
export class ProductPageModule {}
